export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

// Service configuration constants
export const USE_CASE_INCIDENT_REPORT = "incident_report";
export const DEFAULT_LANGUAGE_CODE = "en-US";

// Profile use-case types (must match backend constants.py)
export const USE_CASE_INITIAL_INFORMATION = "initial_information";
export const USE_CASE_INITIAL_ENCOUNTER = "initial_encounter";
export const USE_CASE_INITIAL_INFORMATION_AND_ENCOUNTER = "initial_information_and_encounter";

// Field sentinel values
export const FIELD_VALUE_EXTRACTING = "<EXTRACTING>";

// Supported language options for bilingual mode (comma-separated string)
export const LANGUAGE_OPTIONS_BILINGUAL_EN_ES = "en-US,es-US";

// Session metadata keys.
// Wire contract shared with the backend (WHSNavigatorService constants.py
// METADATA_KEY_*) — keep the two in sync.
export const METADATA_KEYS = {
  CASE_ID: "case_id",
  AUSTIN_LINK: "AUSTIN_LINK",
  CASE_ID_LINKED_BY: "case_id_linked_by",
  CASE_ID_LINKED_AT: "case_id_linked_at",
  SESSION_NAME: "session_name",
  SESSION_SNAPSHOT: "session_snapshot",
  // Merge links: the merged session lists its sources, each archived source names the
  // session it went into, and both sides carry the merge job record.
  MERGED_FROM: "merged_from",
  MERGED_INTO: "merged_into",
  MERGE: "merge",
} as const;

// EditHistoryEntry.edited_by prefixes; edited_by is "<PREFIX>#<ref>".
// Wire contract shared with the backend (constants.py EDIT_SOURCE_*), so keep the two in sync.
export const EDIT_SOURCES = {
  TRANSCRIPT_LLM: "TRANSCRIPT_LLM_EXTRACTION",
  NOTE_LLM: "NOTE_LLM_EXTRACTION",
  AUTOFILL_REEXTRACTION: "AUTO_FILL_REEXTRACTION",
  USER_OVERRIDE: "USER_OVERRIDE",
  USER_VALIDATION: "USER_VALIDATION",
  AUSTIN_SUBMIT: "AUSTIN_SUBMIT",
  MERGE: "MERGE",
} as const;

// A merge always combines exactly this many sessions.
export const MERGE_SELECTION_SIZE = 2;

// Sub-keys of the Session.metrics attribute (client-reported UX latency).
// Wire contract shared with the backend (constants.py METRIC_KEY_*) — keep in sync.
export const METRIC_KEYS = {
  BACKFILL_LATENCY: "backfill_latency",
  VALIDATION_LATENCY: "validation_latency",
} as const;
